import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form2";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content1";
import {
  Get_All_Catagory,
  Service_By_Catagory,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import toast from "react-hot-toast";
import { Add_Group } from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import { Trash2 } from "lucide-react";
import { No_Negetive_Input_regex } from "../../../../Utils/Common_regex";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

const AddStrategy = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const AdminToken = JSON.parse(localStorage.getItem("user_details")).token;

  const [state, setstate] = useState([]);
  const [SerachService, setSerachService] = useState("");
  const [groupname, setGroupname] = useState("");
  const [GetAllSgments, setGetAllSgments] = useState({
    loading: true,
    data: [],
  });
  const [allServices, setAllServices] = useState({
    loading: true,
    data: [],
  });
  const [selectedServices, setSelectedServices] = useState([]);
  const [GroupQty, setGroupQty] = useState([]);
  const [selectAllFiltered, setSelectAllFiltered] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(selectedServices.length / itemsPerPage);

  const paginatedServices = selectedServices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formik = useFormik({
    initialValues: {
      groupname: "",
      segment: false,
    },
    validate: (values) => {
      const errors = {};

      return errors;
    },
    onSubmit: async (values) => {
      if (!groupname) {
        toast.error("Please Select Group Name ");
        return;
      }
      let checkValid = true;

      if (selectedServices.length == 0) {
        toast.error("Please Select Atleast one service");
        return;
      }
      selectedServices &&
        selectedServices.map((item) => {
          if (item.lotSize !== 1) {
            if (item.group_qty % item.lotSize !== 0) {
              toast.warn(`Please Enter Valid Lot Size Inside ${item.name}`);

              checkValid = false;
              return;
            }
            return;
          }
          return;
        });

      if (checkValid) {
        await dispatch(
          Add_Group({
            groupdetails: { name: groupname },
            services_id: selectedServices,
          })
        ).then((response) => {
          if (response.payload.status) {
            toast.success(response.payload.msg);
            setTimeout(() => {
              navigate("/admin/groupservices");
            }, 1000);
          } else {
            toast.error(response.payload.msg);
          }
        });
      }
    },
  });

  useEffect(() => {
    if (selectedServices.length === 30) {
      setSelectAllFiltered(true);
    } else {
      setSelectAllFiltered(false);
    }
  }, [selectedServices]);

  useEffect(() => {
    getservice();
  }, []);

  useEffect(() => {
    filterFunction();
  }, [SerachService]);

  useEffect(() => {
    data();
  }, []);

  useEffect(() => {
    setSerachService("");
    setSelectAllFiltered(false);
  }, []);

  function handleServiceChange(
    event,
    id,
    name,
    segment,
    lotSize,
    instrumenttype
  ) {
    const isChecked = event.target.checked;

    setSelectedServices((prevInfo) => {
      if (isChecked) {
        if (prevInfo.length >= 30) {
          event.target.checked = false;
          return prevInfo;
        }

        // Add new selection
        return [
          ...prevInfo,
          {
            service_id: id,
            name,
            segment,
            group_qty: 0,
            lotSize,
            product_type: instrumenttype === "OPTSTK" ? 1 : 2,
          },
        ];
      } else {
        // Remove unchecked
        return prevInfo.filter((info) => info.service_id !== id);
      }
    });
  }

  const InputGroupQty = (event, id, servicename, segment, lotSize) => {
    const updatedQty =
      event.target.value === "" ? 0 : parseInt(event.target.value);

    setSelectedServices((prevInfo) =>
      prevInfo.map((info) =>
        info.service_id === id
          ? {
            ...info,
            group_qty: updatedQty,
          }
          : info
      )
    );

    // Update the quantity in the GroupQty array
    setGroupQty((prevQtys) => [
      ...prevQtys.filter((qtyInfo) => qtyInfo.service_id !== id),
      {
        service_id: id,
        segment: segment,
        name: servicename,
        group_qty: updatedQty,
      },
    ]);
  };

  const remoeveService = (id) => {
    if (window.confirm("Do you want to delete")) {
      let test = selectedServices.filter((item) => {
        return item.service_id !== id;
      });
      let checkboxes = document.querySelectorAll(`#service-${id}`);
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      setSelectedServices(test);
    }
  };

  const getservice = async () => {
    await dispatch(Get_All_Catagory())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setGetAllSgments({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const data = async () => {
    setAllServices({
      loading: false,
      data: [],
    });

    await dispatch(
      Service_By_Catagory({ category: "6878f8d077603ec4430d04ed" })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllServices({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const filterFunction = async () => {
    const search = SerachService.toLowerCase().trim();

    if (search === "") {
      setstate([]);
      return;
    }

    const filteredData = allServices.data.filter((item) =>
      item.name.toLowerCase().startsWith(search)
    );

    setstate(filteredData);
  };


  const fields = [];

  const columns = [
    // {
    //   name: '#',
    //   cell: (row, index) => index + 1,
    //   width: '60px',
    // },
    {
      name: "Service Name",
      selector: (row) => row.name,
      sortable: true,
    },
    // {
    //   name: "Lot Size",
    //   selector: (row) => row.lotSize,
    //   sortable: true,
    // },
    // {
    //   name: "Quantity",
    //   cell: (row) => (
    //     <input
    //       type="number"
    //       className="form-control"
    //       style={{ width: "80px", fontSize: "0.8rem", padding: "4px" }}
    //       placeholder="Enter Qty"
    //       defaultValue={row.group_qty || 0}
    //       min={0}
    //       onChange={(e) =>
    //         InputGroupQty(
    //           e,
    //           row.service_id,
    //           row.name,
    //           row.segment,
    //           row.group_qty,
    //           row.lotSize
    //         )
    //       }
    //     />
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    // },
    {
      name: "Remove",
      cell: (row) => (
        <Trash2
          className="text-danger"
          style={{ cursor: "pointer" }}
          onClick={() => remoeveService(row.service_id)}
        />
      ),
      button: true,
      width: "100px",
    },
  ];

  const AddProductType = (id, e) => {
    setSelectedServices((prevServices) =>
      prevServices.map((service) =>
        service.service_id === id.service_id
          ? { ...service, product_type: e.target.value }
          : service
      )
    );
  };

  const getExchangeBySymbol = (name) => {
    if (name.endsWith("USD")) return "CoinDCX";
    if (name.endsWith("INR")) return "Coinswitch-inr";
    return null;
  };


  return (
    <>
      <Content
        Page_title="Add Group "
        button_title="Back"
        route="/admin/groupservices"
        additional_field={
          <div>
            <h5>Select Services And Quantity</h5>
            <Table columns={columns} data={selectedServices} />
          </div>
        }
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Add Group"
          title="addstrategy"
          additional_field={
            <>
              <div className="row g-3">
                <div className="col-md-6 px-2 ">
                  <label>Group Name *</label>
                  <input
                    type="test"
                    className="form-control"
                    placeholder="Group name"
                    onChange={(e) => {
                      setGroupname(e.target.value);
                    }}
                    value={groupname}
                  />
                </div>

                <div className="col-md-6 px-2  ">
                  <label>Seach *</label>
                  <input
                    type="test"
                    className="form-control"
                    placeholder="Search ..."
                    onChange={(e) => {
                      setSerachService(e.target.value);
                    }}
                    value={SerachService}
                  />
                </div>

                <div
                  className="col-lg-12"
                  style={{
                    overflowY: state.length > 0 ? "auto" : "hidden",
                    overflowX: "hidden",
                    height: state.length > 0 ? "50vh" : "auto",
                  }}
                >
                  {state.length > 0 && (
                    <div className="row g-2 m-0">
                      {/* ✅ Select All Checkbox */}
                      <div className="col-md-4 mb-2">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="selectall"
                            checked={selectAllFiltered}
                            onChange={() => {
                              if (state.length === 0) return;

                              // 🔍 Detect mixed exchange in filtered list
                              const hasUSD = state.some((s) =>
                                s.name?.endsWith("USD")
                              );
                              const hasINR = state.some((s) =>
                                s.name?.endsWith("INR")
                              );


                              if (hasUSD && hasINR) {
                                toast.error(
                                  "Select All Not allowed ( only Select USD or INR )"
                                );
                                return;
                              }

                              if (!selectAllFiltered) {
                                const first30 = state.slice(0, 30).map((service) => ({
                                  service_id: service._id,
                                  name: service.name,
                                  segment:
                                    service.category_info?.category || "N/A",
                                  group_qty: 0,
                                  lotSize: service.lotSize,
                                  product_type:
                                    service.instrumenttype === "OPTSTK"
                                      ? 1
                                      : 2,
                                }));

                                setSelectedServices(first30);
                                setSelectAllFiltered(true);
                              } else {
                                setSelectedServices([]);
                                setSelectAllFiltered(false);
                              }
                            }}

                          />
                          <label
                            className="ms-1 form-check-label"
                            htmlFor="selectall"
                          >
                            Select All
                          </label>
                        </div>
                      </div>

                      {/* ✅ Individual Checkboxes */}
                      {state.map((service) => (
                        <div key={service._id} className="col-md-4 mb-2">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`service-${service._id}`}
                              checked={selectedServices.some(
                                (info) => info.service_id === service._id
                              )}
                              onChange={(e) => {
                                const currentExchange = getExchangeBySymbol(service.name);

                                const alreadySelectedExchange =
                                  selectedServices.length > 0
                                    ? getExchangeBySymbol(selectedServices[0].name)
                                    : null;

                                // ❌ Block if different exchange
                                if (
                                  e.target.checked &&
                                  alreadySelectedExchange &&
                                  currentExchange !== alreadySelectedExchange
                                ) {
                                  toast.error(
                                    "You can select only on currecy At a time (USD or INR)"
                                  );
                                  e.target.checked = false;
                                  return;
                                }

                                handleServiceChange(
                                  e,
                                  service._id,
                                  service.name,
                                  service.category_info?.category || "N/A",
                                  service.lotSize,
                                  service.instrumenttype
                                );
                              }}
                            />

                            <label
                              className="ms-1 form-check-label"
                              htmlFor={`service-${service._id}`}
                            >
                              {service.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          }
        />
      </Content>
    </>
  );
};

export default AddStrategy;
